module.exports = __webpack_public_path__ + "img/ET_Logo.4c9b446f.png";